import "@/App.css";
import { useEffect, useState } from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "@/contexts/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import Layout from "@/components/Layout";
import { getServerConfig } from "@/lib/api";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import Dashboard from "@/pages/Dashboard";
import Applications from "@/pages/Applications";
import ApplicationDetail from "@/pages/ApplicationDetail";
import AuthorizeBuilder from "@/pages/AuthorizeBuilder";
import OAuthAuthorize from "@/pages/OAuthAuthorize";
import OAuthCallback from "@/pages/OAuthCallback";
import SubMerchants from "@/pages/SubMerchants";
import SubMerchantDetail from "@/pages/SubMerchantDetail";
import WebhooksPage from "@/pages/Webhooks";
import AuditLog from "@/pages/AuditLog";
import { Toaster } from "@/components/ui/sonner";

function ProtectedShell({ children }) {
  return (
    <ProtectedRoute>
      <Layout>{children}</Layout>
    </ProtectedRoute>
  );
}

function App() {
  const [cfg, setCfg] = useState(null);
  useEffect(() => { getServerConfig().then(setCfg).catch(() => setCfg({ features: { mock_consent_screen: false } })); }, []);
  const showMockConsent = cfg?.features?.mock_consent_screen;

  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <Routes>
            <Route path="/" element={<Navigate to="/dashboard" replace />} />
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />

            {/* Mock Razorpay authorize page (mock mode only, no auth — sub-merchant flow) */}
            {showMockConsent && <Route path="/oauth/authorize" element={<OAuthAuthorize />} />}

            {/* Callback (must run logged-in to exchange code via partner credentials) */}
            <Route path="/oauth/callback" element={<ProtectedShell><OAuthCallback /></ProtectedShell>} />

            <Route path="/dashboard" element={<ProtectedShell><Dashboard /></ProtectedShell>} />
            <Route path="/applications" element={<ProtectedShell><Applications /></ProtectedShell>} />
            <Route path="/applications/:id" element={<ProtectedShell><ApplicationDetail /></ProtectedShell>} />
            <Route path="/authorize-builder" element={<ProtectedShell><AuthorizeBuilder /></ProtectedShell>} />
            <Route path="/submerchants" element={<ProtectedShell><SubMerchants /></ProtectedShell>} />
            <Route path="/submerchants/:id" element={<ProtectedShell><SubMerchantDetail /></ProtectedShell>} />
            <Route path="/webhooks" element={<ProtectedShell><WebhooksPage /></ProtectedShell>} />
            <Route path="/audit-log" element={<ProtectedShell><AuditLog /></ProtectedShell>} />

            <Route path="*" element={<Navigate to="/dashboard" replace />} />
          </Routes>
          <Toaster richColors position="top-right" />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
